module.exports = __webpack_public_path__ + "static/media/imagem15.c9914caa.jpeg";